import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const CircularProgressCenter = (props) => (
  <Box {...props} display="flex" alignItems="center" justifyContent="center" marginTop="150px">
    <CircularProgress />
  </Box>
);
